import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import GlobalCssOverride from "./ThemeProvider";
import { AuthProvider } from "./context/AuthContext";
import { AlertProvider } from "./context/AlertContext";
import { LoaderProvider } from "./context/LoaderContext";
import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <GlobalCssOverride>
    <AuthProvider>
      <AlertProvider>
        <LoaderProvider>
          <App />
        </LoaderProvider>
      </AlertProvider>
    </AuthProvider>
  </GlobalCssOverride>,
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
